import { oneDecimalPercentFormat } from 'common/formats/formats';
import { ValuationsApproach } from 'common/types/valuation';
import { PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { VOLATILITY_CUSTOM_KEY } from 'pages/ValuationsAllocation/approaches/FutureExit/AllocationMethodTable/utils/constants';
import {
  ALLOCATION_SCENARIO_METHOD_OPM,
  ALLOCATION_SCENARIO_TYPE_BACKSOLVE,
  ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT,
} from 'pages/ValuationsAllocation/common/constants/allocation';
import calculateVolatilityValue from 'pages/ValuationsAllocation/util/calculateVolatilityValue/calculateVolatilityValue';
import { getApproachTableName } from 'pages/ValuationsAllocation/util/getApproachTableName';
import { getNumberValue } from 'utilities';
import { HandleVolatilityParams } from './types';

const handleVolatility = (params: HandleVolatilityParams) => {
  const {
    cell,
    maturityCell,
    isApproachWithOPM,
    scenarioMethod,
    scenarioType,
    relatedApproachOPMTableName,
    isPublicCompsApproachSelected,
    gpcApproach,
  } = params;

  cell.dbDecimalPlaces = 4;
  cell.dbType = 'number';
  cell.format = oneDecimalPercentFormat;
  cell.greaterThan = 0;
  cell.gridType = 'percentage';
  cell.isRequired = true;

  const approachTableName = gpcApproach
    ? getApproachTableName({
      approach: gpcApproach,
      tableSuffix: PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
    })
    : null;

  if (scenarioMethod && [ALLOCATION_SCENARIO_METHOD_OPM].includes(getNumberValue(scenarioMethod))) {
    if (!isPublicCompsApproachSelected) {
      cell.readOnly = false;
    }
    if (approachTableName && maturityCell) {
      const maturityValue = Number(maturityCell.value ?? 1);
      const volatilityExpr = calculateVolatilityValue(
        maturityValue,
        gpcApproach as ValuationsApproach,
        PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
        maturityValue.toString()
      );
      cell.expr = volatilityExpr;
    }
  } else {
    cell.gridType = 'string';
    cell.value = undefined;
  }

  if (
    scenarioType
    && [ALLOCATION_SCENARIO_TYPE_BACKSOLVE, ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT].includes(getNumberValue(scenarioType))
  ) {
    cell.readOnly = true;
    if (
      scenarioMethod
      && [ALLOCATION_SCENARIO_METHOD_OPM].includes(getNumberValue(scenarioMethod))
      && isApproachWithOPM
    ) {
      cell.expr = `=${relatedApproachOPMTableName}.${VOLATILITY_CUSTOM_KEY}`;
    }
  }
};

export default handleVolatility;
